export class Dictionary {
    isEmpty() {
        for (const key in this) {
            return false;
        }
        return true;
    }
    count() {
        let i = 0;
        for (const key in this) {
            i++;
        }
        return i;
    }
    add(key, value) {
        if (typeof this[key] !== "undefined")
            throw new Error("key already exists");
        this[key] = value;
    }
    get(key) {
        return this[key];
    }
    set(key, value) {
        this[key] = value;
    }
    remove(key) {
        delete this[key];
    }
    keys() {
        const keys = [];
        for (const key in this) {
            keys.push(key);
        }
        return keys;
    }
    keysForEach(func) {
        for (const key in this) {
            func(key);
        }
    }
    values() {
        const values = [];
        for (const key in this) {
            values.push(this[key]);
        }
        return values;
    }
    valuesForEach(func) {
        for (const key in this) {
            func(this[key]);
        }
    }
    forEach(func) {
        this.keysForEach(k => {
            func(k, this.get(k));
        });
    }
    containsKey(key) {
        if (typeof this[key] === "undefined") {
            return false;
        }
        return true;
    }
    clear() {
        const keys = this.keys();
        keys.forEach(k => delete this[k]);
    }
    copyFrom(other) {
        other.keys().forEach(x => {
            const val = other.get(x);
            this.add(x, val);
        });
    }
    clone() {
        const clone = new Dictionary();
        clone.copyFrom(this);
        return clone;
    }
}
